import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import { ElementType } from 'react';

import { useSite } from '../../contexts/SiteContext';
import RegionHorizontalCard from '../cards/RegionHorizontalCard';
import PresentationList, { PresentationListProps } from './PresentationList';

import styles from '../../styles/lists/regions-list.module.css';

const CardComponents = {
    Horizontal: RegionHorizontalCard,
};

interface RegionsListProps extends Omit<PresentationListProps<Region>, 'cardComponent'> {
    cardComponent?: ElementType | null;
    cardType?: string | null;
}

function RegionsList({
    cardType = null,
    cardComponent = null,
    itemsClassName = null,
    ...props
}: RegionsListProps) {
    const { regions = null } = useSite();
    return (
        <PresentationList<Region>
            items={regions}
            withoutLoader
            paginated={false}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, RegionHorizontalCard)
            }
            itemsClassName={classNames([styles.items, itemsClassName])}
        />
    );
}

export default RegionsList;
